import { motion } from "framer-motion";
import { Link } from "react-router-dom";

/* ═══════════════════════════════════════════
   CUSTOM SVG AVATARS — detailed silhouettes
   ═══════════════════════════════════════════ */

const ArtsAvatar = () => (
  <svg viewBox="0 0 120 120" width="120" height="120" fill="none">
    <path d="M60 12c-20 0-32 14-32 32 0 4 1 7 2 10l6-2c-1-2-2-5-2-8 0-15 10-26 26-26s26 11 26 26c0 3-1 6-2 8l6 2c1-3 2-6 2-10 0-18-12-32-32-32z" fill="#e8d5c4"/>
    <path d="M28 54c-2 8-1 18 4 26l4-3c-4-6-5-14-3-21l-5-2z" fill="#d4b896"/>
    <path d="M92 54c2 8 1 18-4 26l-4-3c4-6 5-14 3-21l5-2z" fill="#d4b896"/>
    <circle cx="60" cy="52" r="22" fill="#f5dcc3"/>
    <ellipse cx="52" cy="50" rx="2.5" ry="3" fill="#3e2723"/>
    <ellipse cx="68" cy="50" rx="2.5" ry="3" fill="#3e2723"/>
    <path d="M54 58q6 5 12 0" stroke="#c48b6a" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
    <ellipse cx="60" cy="32" rx="26" ry="10" fill="#ad1457"/>
    <circle cx="60" cy="26" r="5" fill="#ad1457"/>
    <ellipse cx="60" cy="33" rx="22" ry="7" fill="#c2185b"/>
    <rect x="54" y="72" width="12" height="10" rx="4" fill="#f5dcc3"/>
    <path d="M30 110c0-22 14-30 30-30s30 8 30 30" fill="#ad1457"/>
    <path d="M44 88l16 8 16-8" stroke="#f8bbd0" strokeWidth="2" fill="none"/>
    <rect x="84" y="85" width="3" height="20" rx="1" fill="#8d6e63" transform="rotate(15 85 85)"/>
    <rect x="83" y="82" width="5" height="6" rx="1" fill="#ff7043" transform="rotate(15 85 85)"/>
  </svg>
);

const CommerceAvatar = () => (
  <svg viewBox="0 0 120 120" width="120" height="120" fill="none">
    <path d="M38 44c0-14 10-24 22-24s22 10 22 24c0 2 0 4-1 6h-42c-1-2-1-4-1-6z" fill="#4e342e"/>
    <circle cx="60" cy="52" r="22" fill="#e8cba7"/>
    <circle cx="51" cy="50" r="7" stroke="#455a64" strokeWidth="2" fill="none"/>
    <circle cx="69" cy="50" r="7" stroke="#455a64" strokeWidth="2" fill="none"/>
    <line x1="58" y1="50" x2="62" y2="50" stroke="#455a64" strokeWidth="2"/>
    <line x1="44" y1="50" x2="38" y2="48" stroke="#455a64" strokeWidth="1.5"/>
    <line x1="76" y1="50" x2="82" y2="48" stroke="#455a64" strokeWidth="1.5"/>
    <ellipse cx="51" cy="50" rx="2" ry="2.5" fill="#3e2723"/>
    <ellipse cx="69" cy="50" rx="2" ry="2.5" fill="#3e2723"/>
    <path d="M54 60q6 4 12 0" stroke="#b08968" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
    <rect x="54" y="72" width="12" height="10" rx="4" fill="#e8cba7"/>
    <path d="M30 110c0-22 14-30 30-30s30 8 30 30" fill="#1b5e20"/>
    <polygon points="60,82 56,92 60,105 64,92" fill="#f9a825"/>
    <path d="M52 82l8 6 8-6" stroke="#c8e6c9" strokeWidth="2" fill="none"/>
  </svg>
);

const BiotechAvatar = () => (
  <svg viewBox="0 0 120 120" width="120" height="120" fill="none">
    <path d="M38 48c0-16 10-28 22-28s22 12 22 28c0 1 0 2 0 3h-44c0-1 0-2 0-3z" fill="#1a1a2e"/>
    <circle cx="60" cy="52" r="22" fill="#d4a574"/>
    <ellipse cx="52" cy="50" rx="2.5" ry="3" fill="#1a1a2e"/>
    <ellipse cx="68" cy="50" rx="2.5" ry="3" fill="#1a1a2e"/>
    <path d="M54 59q6 4 12 0" stroke="#a67c52" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
    <rect x="54" y="72" width="12" height="10" rx="4" fill="#d4a574"/>
    <path d="M30 110c0-22 14-30 30-30s30 8 30 30" fill="#f5f5f5"/>
    <path d="M48 82l12 8 12-8" stroke="#e0e0e0" strokeWidth="3" fill="none"/>
    <circle cx="60" cy="95" r="2" fill="#bdbdbd"/>
    <circle cx="60" cy="103" r="2" fill="#bdbdbd"/>
    <path d="M40 38c0-4 9-8 20-8s20 4 20 8" stroke="#4a148c" strokeWidth="3" fill="none"/>
    <rect x="42" y="34" width="14" height="8" rx="4" fill="#ce93d8" opacity="0.5" stroke="#4a148c" strokeWidth="1"/>
    <rect x="64" y="34" width="14" height="8" rx="4" fill="#ce93d8" opacity="0.5" stroke="#4a148c" strokeWidth="1"/>
    <rect x="82" y="78" width="4" height="22" rx="2" fill="#ce93d8" stroke="#4a148c" strokeWidth="1"/>
    <ellipse cx="84" cy="100" rx="3" ry="2" fill="#7b1fa2"/>
  </svg>
);

const EngineeringAvatar = () => (
  <svg viewBox="0 0 120 120" width="120" height="120" fill="none">
    <ellipse cx="60" cy="36" rx="28" ry="14" fill="#e65100"/>
    <rect x="34" y="30" width="52" height="10" rx="4" fill="#ef6c00"/>
    <rect x="38" y="25" width="44" height="8" rx="4" fill="#f57c00"/>
    <ellipse cx="60" cy="40" rx="30" ry="6" fill="#e65100"/>
    <circle cx="60" cy="54" r="22" fill="#f0d5b8"/>
    <ellipse cx="52" cy="52" rx="2.5" ry="3" fill="#3e2723"/>
    <ellipse cx="68" cy="52" rx="2.5" ry="3" fill="#3e2723"/>
    <path d="M52 61q8 6 16 0" stroke="#c48b6a" strokeWidth="1.8" fill="none" strokeLinecap="round"/>
    <rect x="54" y="74" width="12" height="10" rx="4" fill="#f0d5b8"/>
    <path d="M30 110c0-22 14-30 30-30s30 8 30 30" fill="#37474f"/>
    <line x1="50" y1="84" x2="50" y2="110" stroke="#ff6f00" strokeWidth="3"/>
    <line x1="70" y1="84" x2="70" y2="110" stroke="#ff6f00" strokeWidth="3"/>
    <rect x="54" y="92" width="12" height="8" rx="2" stroke="#546e7a" strokeWidth="1.5" fill="none"/>
    <rect x="30" y="88" width="3" height="18" rx="1" fill="#90a4ae" transform="rotate(-20 31 88)"/>
    <circle cx="30" cy="86" r="5" stroke="#90a4ae" strokeWidth="2.5" fill="none" transform="rotate(-20 31 88)"/>
  </svg>
);

/* ═══════════════════════════════════════════
   CUSTOM SVG ICONS for benefits
   ═══════════════════════════════════════════ */

const RocketIcon = () => (
  <svg viewBox="0 0 48 48" width="48" height="48" fill="none">
    <path d="M24 4c-4 8-6 16-6 24h12c0-8-2-16-6-24z" fill="hsl(142 71% 45%)" />
    <path d="M18 28l-6 8 8-2" fill="hsl(142 71% 35%)" />
    <path d="M30 28l6 8-8-2" fill="hsl(142 71% 35%)" />
    <ellipse cx="24" cy="20" rx="3" ry="4" fill="white" opacity="0.9" />
    <path d="M20 32c0 6 2 12 4 16 2-4 4-10 4-16" fill="hsl(25 95% 53%)" />
  </svg>
);

const MentorIcon = () => (
  <svg viewBox="0 0 48 48" width="48" height="48" fill="none">
    <circle cx="24" cy="14" r="10" fill="hsl(142 71% 45%)" />
    <path d="M24 6l2 5h5l-4 3 1.5 5L24 16l-4.5 3L21 14l-4-3h5z" fill="white" />
    <path d="M12 44c0-10 5-16 12-16s12 6 12 16" fill="hsl(142 71% 35%)" />
    <circle cx="24" cy="34" r="3" fill="white" opacity="0.8" />
  </svg>
);

const GrowthIcon = () => (
  <svg viewBox="0 0 48 48" width="48" height="48" fill="none">
    <rect x="6" y="32" width="8" height="12" rx="2" fill="hsl(142 71% 45%)" opacity="0.5" />
    <rect x="18" y="24" width="8" height="20" rx="2" fill="hsl(142 71% 45%)" opacity="0.7" />
    <rect x="30" y="14" width="8" height="30" rx="2" fill="hsl(142 71% 45%)" />
    <path d="M8 28l14-14 6 6 12-14" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M34 6h8v8" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/* ═══════════════════════════════════════════
   DISCIPLINE ICONS
   ═══════════════════════════════════════════ */

const PaletteIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="13.5" cy="6.5" r="2"/><circle cx="17.5" cy="10.5" r="2"/><circle cx="8.5" cy="7.5" r="2"/><circle cx="6.5" cy="12" r="2"/>
    <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.93 0 1.5-.67 1.5-1.5 0-.4-.13-.76-.38-1.07-.25-.3-.38-.67-.38-1.07 0-.83.67-1.5 1.5-1.5H16c3.31 0 6-2.69 6-6 0-5.17-4.5-8.86-10-8.86z"/>
  </svg>
);

const ChartBarIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="12" width="4" height="9" rx="1"/><rect x="10" y="7" width="4" height="14" rx="1"/><rect x="17" y="3" width="4" height="18" rx="1"/>
  </svg>
);

const DnaIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round">
    <path d="M2 15c6.667-6 13.333 0 20-6"/><path d="M9 22c1.798-1.998 2.573-3.995 2.572-5.993"/><path d="M15 2c-1.798 1.998-2.573 3.995-2.572 5.993"/><path d="M2 9c6.667 6 13.333 0 20 6"/>
  </svg>
);

const CpuIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/>
    <path d="M15 2v2M15 20v2M2 15h2M2 9h2M20 15h2M20 9h2M9 2v2M9 20v2"/>
  </svg>
);

/* ═══════════════════════════════════════════
   DATA
   ═══════════════════════════════════════════ */

const students = [
  { label: "Science", desc: "Including relevant life-science fields", Avatar: BiotechAvatar, color: "#4a148c", glow: "rgba(74,20,140,0.35)", icons: [DnaIcon] },
  { label: "Commerce", desc: "Business and analytical perspectives", Avatar: CommerceAvatar, color: "#1b5e20", glow: "rgba(27,94,32,0.35)", icons: [ChartBarIcon] },
  { label: "Arts & Humanities", desc: "Creative and human-centered perspectives", Avatar: ArtsAvatar, color: "#ad1457", glow: "rgba(173,20,87,0.35)", icons: [PaletteIcon] },
  { label: "Other Disciplines", desc: "Opportunities vary by internship track", Avatar: EngineeringAvatar, color: "#e65100", glow: "rgba(230,81,0,0.35)", icons: [CpuIcon] },
];

const benefits = [
  { Icon: RocketIcon, title: "Project-Based Learning", desc: "Develop practical skills through assigned projects aligned with your internship role.", number: "01" },
  { Icon: MentorIcon, title: "Mentor Guidance", desc: "Receive guidance and feedback from designated mentors, subject to programme availability.", number: "02" },
  { Icon: GrowthIcon, title: "Career Readiness for Diverse Opportunities", desc: "Develop transferable skills and practical experience to prepare for opportunities across a wide range of companies and organisations.", number: "03" },
];

/* ═══════════════════════════════════════════
   ANIMATION HELPERS
   ═══════════════════════════════════════════ */

const EASE = [0.22, 1, 0.36, 1];

const staggerContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08 } },
};

const wordAnim = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: EASE } },
};

const AnimatedHeading = ({ text, className, greenWords = [] }) => {
  const words = text.split(" ");

  return (
    <motion.h2
      className={className}
      variants={staggerContainer}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-50px" }}
    >
      {words.map((word, i) => (
        <motion.span
          key={i}
          variants={wordAnim}
          className="inline-block mr-[0.3em]"
          style={greenWords.includes(word)
            ? { color: "hsl(142 71% 45%)" }
            : undefined}
        >
          {word}
        </motion.span>
      ))}
    </motion.h2>
  );
};
  
const AnimatedText = ({ text, className, delay = 0 }) => (
  <motion.p
    className={className}
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-30px" }}
    transition={{ duration: 0.7, delay, ease: EASE }}
  >
    {text}
  </motion.p>
);

/* ═══════════════════════════════════════════
   COMPONENT
   ═══════════════════════════════════════════ */

export default function WhatisGyan() {
  return (
    <section
      className="relative overflow-hidden"
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[hsl(220,60%,18%)] via-[hsl(218,55%,24%)] to-[hsl(224,65%,12%)]" />

      {/* Glow blobs */}
      <motion.div
        animate={{ y: [0, -30, 0] }}
        transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
        className="absolute top-20 left-1/4 w-[500px] h-[500px] rounded-full bg-[hsl(217,80%,50%)] opacity-[0.12] blur-[120px]"
      />
      <motion.div
        animate={{ y: [0, 30, 0] }}
        transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
        className="absolute bottom-0 right-1/4 w-[400px] h-[400px] rounded-full bg-[hsl(142,71%,45%)] opacity-[0.08] blur-[100px]"
      />

      <div className="relative z-10 max-w-6xl mx-auto px-6">

        {/* ────────── SECTION 1: WHAT IS GYAN ────────── */}
        <div className="pt-28 pb-20">
          <motion.p
            initial={{ opacity: 0, letterSpacing: "0.1em" }}
            whileInView={{ opacity: 1, letterSpacing: "0.4em" }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: EASE }}
            className="uppercase text-[11px] text-[hsl(142,71%,55%)] font-semibold mb-6 text-center"
          >
            INTRODUCTION
          </motion.p>

          <AnimatedHeading
            text="What is GYAN?"
            greenWords={["GYAN?"]}
            className="text-5xl md:text-7xl font-black text-white leading-tight tracking-tight text-center"
          />

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.3, ease: EASE }}
            className="mt-10 max-w-4xl mx-auto"
          >
            <p className="text-lg md:text-xl text-white/60 leading-relaxed font-light text-center">
              <span className="font-semibold text-[hsl(142,71%,65%)]">Gyan.AiM4u</span>{" "}
              is a dynamic internship platform developed by{" "}
              <span className="text-white/80 font-medium">AiM4u Software Solutions</span>,
              supporting structured learning through internship projects and guidance,
              subject to programme availability and track requirements.
            </p>
          </motion.div>

          {/* Key pillars */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.5, ease: EASE }}
            className="mt-10 max-w-4xl mx-auto grid md:grid-cols-2 gap-6"
          >
            <div className="rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-xl p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-8 h-8 rounded-lg bg-[hsl(142,71%,45%)]/20 flex items-center justify-center">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="hsl(142 71% 55%)" strokeWidth="2" strokeLinecap="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>
                </div>
                <h4 className="text-white font-semibold text-sm">Our Mission</h4>
              </div>
              <p className="text-white/50 text-sm leading-relaxed font-light">
                Bridge the gap between academic concepts and real-world application, empowering students with practical skills in AI, ML, software development, and app development.
              </p>
            </div>
            <div className="rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-xl p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-8 h-8 rounded-lg bg-[hsl(142,71%,45%)]/20 flex items-center justify-center">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="hsl(142 71% 55%)" strokeWidth="2" strokeLinecap="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                </div>
                <h4 className="text-white font-semibold text-sm">Inclusive Growth</h4>
              </div>
              <p className="text-white/50 text-sm leading-relaxed font-light">
                Learning opportunities may be available to students from different academic backgrounds, subject to track requirements and programme availability.
              </p>
            </div>
          </motion.div>
        </div>

        {/* ────────── SECTION 2: DISCIPLINES ────────── */}
        <div className="py-20">
          <motion.p
            initial={{ opacity: 0, letterSpacing: "0.1em" }}
            whileInView={{ opacity: 1, letterSpacing: "0.4em" }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="uppercase text-[11px] text-[hsl(142,71%,55%)] font-semibold mb-6 text-center"
          >
            DISCIPLINES WE EMPOWER
          </motion.p>

          <AnimatedHeading
            text="Opportunities Across Academic Disciplines"
            greenWords={["Academic", "Disciplines"]}
            className="text-5xl md:text-6xl font-black text-white leading-[1.1] tracking-tight text-center"
          />

          <AnimatedText
            text="Explore internship and learning opportunities across diverse academic backgrounds. Specific opportunities and eligibility vary by track."
            className="mt-6 text-lg text-white/50 font-light max-w-2xl mx-auto text-center"
            delay={0.2}
          />

          {/* STUDENT GRID */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mt-16">
            {students.map((s, i) => (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.12, duration: 0.6, ease: EASE }}
                viewport={{ once: true }}
                className="relative group flex flex-col items-center text-center"
              >
                <motion.div
                  whileHover={{ y: -10, scale: 1.06 }}
                  transition={{ type: "spring", stiffness: 260, damping: 20 }}
                >
                  <div
                    className="rounded-full border-[3px] border-white/15 shadow-2xl overflow-hidden bg-white/5 transition-shadow duration-500"
                    style={{ boxShadow: `0 0 0px ${s.glow}` }}
                    onMouseEnter={(e) => (e.currentTarget.style.boxShadow = `0 10px 40px ${s.glow}`)}
                    onMouseLeave={(e) => (e.currentTarget.style.boxShadow = `0 0 0px ${s.glow}`)}
                  >
                    <s.Avatar />
                  </div>
                </motion.div>

                <h4 className="mt-6 text-2xl md:text-3xl font-extrabold text-white tracking-tight">
                  {s.label}
                </h4>

                <p className="text-white/40 text-xs tracking-[0.15em] uppercase mt-1.5">
                  {s.desc}
                </p>

                <motion.div
                  initial={{ width: 0 }}
                  whileInView={{ width: 32 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.4 + i * 0.1, duration: 0.5 }}
                  className="h-[2px] bg-[hsl(142,71%,45%)] mt-4 rounded-full"
                />

                {/* Hover Panel */}
                <div className="absolute top-[110%] left-1/2 -translate-x-1/2 w-[280px] bg-white/95 backdrop-blur-xl rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.35)] p-6 opacity-0 translate-y-6 pointer-events-none group-hover:opacity-100 group-hover:translate-y-0 group-hover:pointer-events-auto transition-all duration-400 z-20">
                  <h5 className="text-[10px] tracking-[0.25em] uppercase font-semibold text-gray-400 mb-3">
                    What <span className="text-[hsl(142,71%,45%)] font-bold">GYAN</span> Enables
                  </h5>
                  {s.label === "Science" && (
                    <p className="text-gray-600 text-sm leading-relaxed font-light">
                      <span className="font-semibold text-gray-800">For Science students:</span>{" "}
                      Explore science and life-science topics, including biotechnology where relevant and available.
                    </p>
                  )}
                  {s.label === "Arts & Humanities" && (
                    <p className="text-gray-600 text-sm leading-relaxed font-light">
                      <span className="font-semibold text-gray-800">For Arts & Humanities students:</span>{" "}
                      Explore relevant communication, content, and creative project activities where available.
                    </p>
                  )}
                  {s.label === "Commerce" && (
                    <p className="text-gray-600 text-sm leading-relaxed font-light">
                      <span className="font-semibold text-gray-800">For Commerce students:</span>{" "}
                      Explore relevant business, analytics, and communication activities where available.
                    </p>
                  )}
                  {s.label === "Other Disciplines" && (
                    <p className="text-gray-600 text-sm leading-relaxed font-light">
                      <span className="font-semibold text-gray-800">For students in other disciplines:</span>{" "}
                      Opportunities depend on the requirements and eligibility criteria of each internship track.
                    </p>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* ────────── SECTION 3: WHY CHOOSE GYAN ────────── */}
        <div className="py-24">
          <motion.p
            initial={{ opacity: 0, letterSpacing: "0.1em" }}
            whileInView={{ opacity: 1, letterSpacing: "0.4em" }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="uppercase text-[11px] text-[hsl(142,71%,55%)] font-semibold mb-6 text-center"
          >
            GROWTH ECOSYSTEM
          </motion.p>

          <AnimatedHeading
            text="Why Students Choose GYAN"
            greenWords={["GYAN"]}
            className="text-5xl md:text-6xl font-black text-white leading-[1.1] tracking-tight text-center"
          />

          <AnimatedText
            text="Not just internships — a structured pathway toward real industry readiness."
            className="mt-6 text-lg text-white/50 font-light max-w-2xl mx-auto text-center"
            delay={0.15}
          />

          <div className="grid md:grid-cols-3 gap-8 mt-16">
            {benefits.map((b, i) => (
              <motion.div
                key={b.title}
                initial={{ opacity: 0, y: 50, rotateY: -8 }}
                whileInView={{ opacity: 1, y: 0, rotateY: 0 }}
                transition={{ delay: i * 0.15, duration: 0.7, ease: EASE }}
                viewport={{ once: true }}
                whileHover={{ y: -10, transition: { duration: 0.3 } }}
                className="relative group"
              >
                {/* White card */}
                <div className="relative rounded-3xl bg-white p-8 md:p-10 shadow-[0_8px_40px_rgba(0,0,0,0.12)] overflow-hidden transition-shadow duration-500 hover:shadow-[0_20px_60px_rgba(0,0,0,0.2)]">
                  {/* Decorative number */}
                  <span className="absolute top-4 right-6 text-[80px] font-black leading-none text-gray-100 select-none pointer-events-none transition-colors duration-500 group-hover:text-[hsl(142,71%,90%)]">
                    {b.number}
                  </span>

                  {/* Accent bar */}
                  <motion.div
                    className="absolute top-0 left-0 w-full h-1 origin-left"
                    style={{ background: "linear-gradient(90deg, hsl(142 71% 45%), hsl(142 71% 60%))" }}
                    initial={{ scaleX: 0 }}
                    whileInView={{ scaleX: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.3 + i * 0.15, duration: 0.6, ease: EASE }}
                  />

                  <div className="relative z-10">
                    <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[hsl(142,71%,45%)] to-[hsl(142,71%,30%)] flex items-center justify-center shadow-lg mb-6">
                      <b.Icon />
                    </div>

                    <h4
                      className="text-2xl md:text-3xl font-extrabold mb-4 leading-tight"
                      style={{
                        background: "linear-gradient(135deg, hsl(220 60% 18%), hsl(142 71% 35%))",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                      }}
                    >
                      {b.title}
                    </h4>

                    <div className="w-10 h-[2px] bg-gradient-to-r from-[hsl(142,71%,45%)] to-transparent mb-4 transition-all duration-500 group-hover:w-16" />

                    <p className="text-gray-500 text-base leading-relaxed font-light">
                      {b.desc}
                    </p>
                  </div>

                  {/* Bottom glow on hover */}
                  <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-[hsl(142,71%,95%)] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* ────────── CTA ────────── */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: EASE }}
          viewport={{ once: true }}
          className="text-center pb-28 pt-8"
        >
          <Link to="/register">
            <motion.button
              whileHover={{ y: -4, boxShadow: "0 25px 70px rgba(34,197,94,0.4)" }}
              whileTap={{ scale: 0.97 }}
              className="px-14 py-5 text-lg font-bold text-white rounded-xl bg-gradient-to-r from-[hsl(142,71%,40%)] to-[hsl(142,71%,50%)] shadow-[0_16px_50px_rgba(34,197,94,0.3)] transition-all duration-300"
            >
              Join GYAN Today
            </motion.button>
          </Link>
        </motion.div>

      </div>
    </section>
  );
}
